import React from 'react';
import {
  Card,
  CardContent,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import moment from 'moment';
import DeleteIcon from '@mui/icons-material/Delete';

import { IResourceFile } from '../../../../store/ResourcesSlice';

interface ResourceCardProps {
  resource: IResourceFile;
  onDelete?: () => void;
}

const cardStyles: React.CSSProperties = {
  borderWidth: '2px',
  borderStyle: 'solid',
  borderColor: '#ededed',
  borderRadius: '12px',
};

const ResourceCard: React.FC<ResourceCardProps> = ({
  resource,
  onDelete = undefined,
}) => {
  let _src = `${process.env.PUBLIC_URL}/images/resourceLib/folder.svg`;

  switch (resource.mimeType) {
    case 'application/pdf':
      _src = `${process.env.PUBLIC_URL}/images/resourceLib/pdf.svg`;
      break;
    case 'image/jpeg':
      _src = `${process.env.PUBLIC_URL}/images/resourceLib/jpg.svg`;
      break;
    default:
      _src = `${process.env.PUBLIC_URL}/images/resourceLib/folder.svg`;
      break;
  }

  const createdAt = moment(resource.createdDate).format('DD MMM YYYY hh:mm A');

  return (
    <Card elevation={0} style={cardStyles}>
      <CardContent style={{ padding: '16px' }}>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          style={{ width: '100%' }}
        >
          <Stack
            direction="row"
            alignItems="center"
            style={{ maxWidth: 'calc(100% - 230px)' }}
          >
            <img
              src={_src}
              alt={resource.title}
              style={{ width: '40px', height: '40px', marginRight: '15px' }}
            />
            <Typography
              className="ellipsis-text"
              variant="subtitle2"
              fontWeight={600}
              title={resource.title}
            >
              {resource.title}
            </Typography>
          </Stack>
          <div style={{ minWidth: '160px' }}>
            <Typography color="secondary" fontWeight={500} title={createdAt}>
              {createdAt}
            </Typography>
          </div>
          <div style={{ minWidth: '40px' }}>
            <IconButton color="error" onClick={onDelete}>
              <DeleteIcon />
            </IconButton>
          </div>
        </Stack>
      </CardContent>
    </Card>
  );
};

export default ResourceCard;
